export class searchBox {
    public searchAttribute: String;
    public minLength: number;
}